<div class="card">
  <div class="card-header bg-light">
    <h5 class="card-title mb-0">{{product.brand}} {{product.name}}</h5>
  </div>
  <img [src]="getPackageImagePath(product.image)" [alt]="product.name" class="card-img-top p-3" style="max-width: 250px; margin: 0 auto;">
  <div class="card-body">
    <div class="specs-container">
      <div class="spec-item" *ngFor="let spec of [
          { icon: 'display', title: 'Display', value: product.display.description },
          { icon: 'cpu', title: 'Chipset', value: product.chipset.description },
          { icon: 'hdd', title: 'Storage', value: product.storage_ram.description },
          { icon: 'camera', title: 'Camera', value: product.camera.description },
          { icon: 'wifi', title: 'Network', value: product.network.description },
          { icon: 'battery', title: 'Battery', value: product.battery.description }
        ]">
        <div class="d-flex align-items-center">
          <img [src]="getIconPath(spec.title)" [alt]="spec.title" class="spec-icon me-2"
            (error)="handleIconError($event)">
          <strong>{{spec.title}}:</strong>
        </div>
        <p class="ms-4 mb-2">{{spec.value}}</p>
      </div>
    </div>
  </div>
</div>